// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./css/components/product/_index.scss
// module id = 72
// module chunks = 0